import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { Route as DeliverableRoute } from '~/core/routes/deliverables/[deliverableId]/_index';
import { Route as DeliverableReceiptRoute } from '~/core/routes/deliverables/[deliverableId]/final-output-report-versions/[receiptId]/_index';
import { Route as DeliverablesRoute } from '~/core/routes/deliverables/_index';

// Exports
const permissions: PermissionsFn = (context) =>
  context.flags.productsDeliverablesPermissions;
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  // Relative to /loans/*
  children: [
    { index: true, element: <DeliverablesRoute /> },
    { path: ':deliverableId', element: <DeliverableRoute /> },
    {
      path: ':deliverableId/final-output-report-versions/:receiptId',
      element: <DeliverableReceiptRoute />,
    },
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
